import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';

import { FGrid, FGridMoneyCell } from '../grid';
import { BudgetValidationQueueRow } from './types';
import { decisionColor, scoreLabel } from './format';

type Props = {
  rows: BudgetValidationQueueRow[];
  selectedId?: number | null;
  loading?: boolean;
  onSelect: (row: BudgetValidationQueueRow) => void;
};

const ScoreCell = (params: GridRenderCellParams) => (
  <Box sx={{ width: '100%', textAlign: 'right' }}>
    <Typography variant="body2" sx={{ fontWeight: 700 }}>
      {Number(params.value || 0).toFixed(1)}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {scoreLabel(params.value)}
    </Typography>
  </Box>
);

const DescriptionCell = (params: GridRenderCellParams) => (
  <Box>
    <Typography variant="body2" sx={{ fontWeight: 600 }}>
      {params.row.nam}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {params.row.dsc}
    </Typography>
  </Box>
);

const DecisionCell = (params: GridRenderCellParams) => (
  <Chip
    size="small"
    label={params.value || 'PENDING'}
    color={decisionColor(params.value)}
  />
);

class BudgetValidationQueuePanel extends React.Component<Props> {
  columns: GridColDef[] = [
    { field: 'scr', headerName: 'Score', width: 110, renderCell: ScoreCell },
    { field: 'src', headerName: 'Source', width: 120 },
    { field: 'ccc', headerName: 'Cost Center', width: 130 },
    { field: 'nam', headerName: 'Description', flex: 1, minWidth: 300, renderCell: DescriptionCell },
    { field: 'rqa', headerName: 'Requested', width: 150, renderCell: FGridMoneyCell },
    { field: 'rca', headerName: 'Recommended', width: 150, renderCell: FGridMoneyCell },
    { field: 'dcc', headerName: 'Decision', width: 140, renderCell: DecisionCell },
  ];

  render() {
    const { rows, selectedId, loading, onSelect } = this.props;

    return (
      <FGrid
        title="Budget Validation Queue"
        subtitle="Prioritized budget items requiring validation decision."
        rows={rows || []}
        columns={this.columns}
        loading={loading}
        height={640}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#eaf2fb' }}
        getRowId={(row: any) => row.rid}
        pageSizeOptions={[25, 50, 100]}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
        onRowClick={(params: any) => onSelect(params.row)}
        getRowClassName={(params: any) =>
          params.row.rid === selectedId ? 'selected-validation-row' : ''
        }
        sx={{
          '& .selected-validation-row': {
            bgcolor: '#e3f2fd',
          },
          '& .MuiDataGrid-row': {
            cursor: 'pointer',
          },
        }}
      />
    );
  }
}

export default BudgetValidationQueuePanel;
